import ROUTES from "@constants/routing";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export interface IAvatarSettingsProps {
  startSession: () => void;
  onRequestLogin?: () => void;
}

const InteractiveChatSettings: React.FC<IAvatarSettingsProps> = ({
  startSession: _startSession,
  onRequestLogin
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleStartSession = () => {
    if (onRequestLogin) {
      onRequestLogin();
      return;
    }
    navigate(ROUTES.WELCOME);
  };

  function showNoAccessParameters() {
    return (
      <>
        <Typography
          component="h3"
          sx={{
            fontSize: { xs: 18, sm: 25 },
            fontWeight: 600,
            textAlign: "center",
            color: "#333333",
            mb: 3
          }}
        >
          {t("chatbot.common.start_chatting")}
        </Typography>
        <Typography
          component="div"
          sx={{
            fontSize: { xs: 14, sm: 16 },
            fontWeight: 325,
            color: "#333333",
            textAlign: "center",
            mb: 3
          }}
        >
          {t("chatbot.common.welcome_message")}
        </Typography>
      </>
    );
  }

  return (
    <Box
      component="section"
      sx={{
        width: 362,
        p: 4,
        mx: "auto",
        textAlign: "center",
        minHeight: "calc(100dvh - 300px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {showNoAccessParameters()}

      <Button
        variant="contained"
        onClick={handleStartSession}
        sx={{
          width: "60%",
          py: 1.5,
          borderRadius: 0,
          textTransform: "none",
          fontSize: { xs: 12, sm: 16 },
          fontWeight: 600,
          bgcolor: theme.palette.primary.main,
          "&:hover": { backgroundColor: theme.palette.primary.dark }
        }}
      >
        {t("chatbot.common.start_session", "Iniciar sesión")}
      </Button>
    </Box>
  );
};

export default InteractiveChatSettings;
